import { v4 as uuidv4 } from 'uuid'

import { NOTIFICATION_LIFETIME, NOTIFICATION_SUCCESS, NOTIFICATION_ERROR } from '@/config/constants'

const Notifications = {
  translator: null,

  setTranslator(translator) {
    this.translator = translator
  },

  $t(key, params = {}) {
    return this.translator ? this.translator(key, params) : key
  },

  $_push(item, lifetime) {
    this.state.items.push(item)

    if (lifetime > 0) {
      window.setTimeout(() => this.remove(item.id), lifetime)
    }
  },

  add(text, type = NOTIFICATION_SUCCESS, lifetime = NOTIFICATION_LIFETIME, id = uuidv4()) {
    this.$_push(
      {
        id,
        text,
        type,
      },
      lifetime
    )
  },

  error(error, lifetime = NOTIFICATION_LIFETIME, id = uuidv4()) {
    const { errorCode, errorLevel } = error

    // don't display same error twice
    if (this.state.items.some(item => (item.errorCode ? item.errorCode === errorCode : false))) {
      return
    }

    this.$_push(
      {
        id,
        errorCode,
        text: errorCode ? this.$t(`error.${errorCode}`) : error,
        type: errorLevel?.toLowerCase() || NOTIFICATION_ERROR,
      },
      lifetime
    )
  },

  clear() {
    this.state.items.splice(0, this.state.items.length)
  },

  remove(id) {
    this.state.items.splice(
      this.state.items.findIndex(i => i.id === id),
      1
    )
  },

  list() {
    return this.state.items
  },

  install(Vue) {
    this.$notification = new Vue()

    this.state = Vue.observable({
      items: [],
    })

    Vue.prototype.$notification = this
  },
}

export default Notifications
